import './config/setup/compositionApi';
import Vue from 'vue';
import { VueWindowSizePlugin } from 'vue-window-size/option-api';
import vimeoPlayer from 'vue-vimeo-player';
import VueYoutube from 'vue-youtube';
import VueMeta from 'vue-meta';
import VueHighlightJS from 'vue-highlightjs';
import router from './config/router';
import App from './App.vue';

// Makes <pre v-highlightjs (...) /> available for all components without having to import it.
Vue.use(VueHighlightJS);

// Makes <youtube (...) /> available for all components to use without having to import it.
Vue.use(VueYoutube);

// Makes vue-vimeo-player available for all components without having to import it.
Vue.use(vimeoPlayer);

// Makes vue-window-size available in all components as this.$windowWidth and this.$windowHeight.
Vue.use(VueWindowSizePlugin);

// Makes vue-meta available in all components as { metaInfo: { meta: [ { tagname: tagvalue } ] } }.
Vue.use(VueMeta);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
